<template>
    <section v-if="addtionalAttirbute && currentCarat">

        <div class="setting_details" v-if="addtionalAttirbute && currentCarat">
           <div class="mb-2 title_flex" @click="toggleRing()" v-if="['anniversary-ring', 'couple-bands-ring', 'band-ring', 'in-stock-ring', 'hoop-earring'].includes(detailData.sub_type)">
                <div class="font-active">
                    <span @click="toggleDetails('setting')">{{labelSettingDetail}}</span>  

                    <span v-if="currentMetal.shape != '' && !['hoop-earring', 'band-ring','anniversary-ring','couple-bands-ring'].includes(detailData.sub_type)"> & Accent details</span> 

                    <!-- <span v-if="detailData.stone_one_shape != null"  @click="toggleDetails('cen_stone')" :class="{ 'active' : tabs.cen_stone }">Center Stone</span>  -->

                </div>
                <SvgHeaderSvg class="for_mobile" :type="dropring ? 'up' : 'down'" />
            </div>

            <div class="ring_data_flex" :class="dropring ? 'show' : 'hide'">

                <div class="ring_box" v-if="detailData.sub_type_1" @click="openModal(ringParams.newstyle)">
                    <div class="ring_box_left">
                        <h5 class="title_h5 caps">{{ detailData.sub_type_1 }}</h5>
                        <p class="mb-0">Style</p>
                    </div>
                    <div class="ring_box_right">
                        <img v-if="detailData.sub_type_1 !== 'classic'" width="100" height="72" :src="'/loose_setting/' + lowercase(detailData.sub_type_1) + '.svg'" alt="Style" />
                        <img v-else width="70" height="72" :src="'/loose_setting/' + lowercase(detailData.sub_type_1) + '.svg'" alt="Style" />
                    </div>
                    <div class="top-icon">
                        <SvgHeaderSvg :type="'ask'" />
                    </div>
                </div>
                
                <div class="d-none vto-do-not-remove">
                    <span class="title">Design No.</span>
                    <span class="description">{{currentMetal.main_sku}}</span>
                </div>
                <div class="ring_box" v-if="['anniversary-ring', 'couple-bands-ring', 'band-ring', 'in-stock-ring'].includes(detailData.sub_type)" @click="openModal(ringParams.newwidth)">
                    <div class="ring_box_left">
                        <h5 class="title_h5 non_cap" v-if="[ 'in-stock-ring'].includes(detailData.sub_type)">{{detailData.setting.min_width}}  /  {{detailData.setting.max_width}} mm</h5>
                        <h5 class="title_h5 non_cap" v-else>{{ addtionalAttirbute.average_width }}</h5>
                        <p class="mb-0">Average Width</p>
                    </div>
                    <div class="ring_box_right">
                        <img width="100" height="72" src="~/assets/loose_setting/bandwidth.svg" alt="band width" />
                    </div>
                    <div class="top-icon">
                        <SvgHeaderSvg :type="'ask'" />
                    </div>
                </div>
                
                <div class="ring_box" v-if="detailData.setting && detailData.setting.side_lot_weight != 0" @click="openModal(ringParams.weight)">
                    <div class="ring_box_left">
                        <h5 class="title_h5 caps">{{ detailData.lot_weight }} Ct</h5>
                        <p class="mb-0">Total Carat Weight</p>
                    </div>
                    <div class="ring_box_right">
                        <img width="100" height="72" src="~/assets/presetdetails/total_ct_w.svg" alt="quantity" />
                    </div>
                    <div class="top-icon">
                        <SvgHeaderSvg :type="'ask'" />
                    </div>
                </div>
                
                <div class="ring_box hoop_mod" v-if="detailData.sub_type === 'hoop-earring'">
                    <div class="ring_box_left">
                        <h5 class="title_h5 caps">Hinged</h5>
                        <p class="mb-0">Back Type</p>
                    </div>
                    <div class="ring_box_right">
                        <img width="120" height="72" src="/loose_setting/hinged.svg" alt="Back Type" />
                    </div>
                    <div class="top-icon">
                        <!-- To Be Upadted with hoop based -->
                        <!-- <ModalSettingStyle /> -->
                    </div>
                </div>
                <!-- <div class="ring_box" v-if="detailData.setting && detailData.setting.side_lot_weight != 0">
                    <div class="ring_box_left">
                        <h5 class="title_h5 caps">{{ detailData.setting.side_stone_shape }}</h5>
                        <p class="mb-0">Shape</p>
                    </div>
                    <div class="ring_box_right pe-md-1">
                        <img v-if="currentMetal.shape.trim().split(/\s+/).length === 1" width="72" height="65" :src="`/loose_setting/${currentMetal.shape.toLowerCase()}.svg`" alt="Shape" />

                        <img v-else width="120" height="72" src="/loose_setting/diamond.svg" alt="Diamond" />
                    </div>
                    <div class="top-icon">
                        <ModalSettingShape :currentMetal="currentMetal.shape" title="Shape"/>
                    </div>
                </div> -->
                <div class="ring_box" v-if="detailData.setting && detailData.setting.side_lot_weight != 0" @click="openModal(ringParams.sideQuantity)">
                    <div class="ring_box_left">
                        <h5 class="title_h5 caps">{{ detailData.setting.num_side_lots }}</h5>
                        <p class="mb-0">Side Stone Quantity</p>
                    </div>
                    <div class="ring_box_right">
                        <img v-if="['in-stock-ring', 'in-stock-earring', 'in-stock-pendant'].includes(detailData.sub_type)" src="~/assets/loose_setting/diamond.svg" alt="Diamond" >

                        <img v-else width="65" height="72" :src="'/loose_setting/' + lowercase(detailData.setting.side_stone_shape) + '.svg'" alt="carat" />
                    </div>
                    <div class="top-icon">
                        <SvgHeaderSvg :type="'ask'" />
                    </div>
                </div>
                
                <div class="ring_box" v-if="detailData.setting && detailData.setting.side_lot_weight != 0" @click="openModal(ringParams.sidecolor)">
                    <div class="ring_box_left">
                        <h5 class="title_h5 caps">{{ detailData.setting.d_color }}</h5>
                        <p class="mb-0">Side Stone <br>Color</p>
                    </div>
                    <div class="ring_box_right">
                        <img width="100" height="100" :src="'/loose_setting/' + lowercase(detailData.setting.d_color ) + '.svg'" alt="color" />
                    </div>
                    <div class="top-icon">
                        <SvgHeaderSvg :type="'ask'" />
                    </div>
                </div>
                
               
                <div class="ring_box" v-if="detailData.setting && detailData.setting.side_lot_weight != 0" @click="openModal(ringParams.sideclarity)">
                    <div class="ring_box_left">
                        <h5 class="title_h5"> {{ detailData.setting.d_clarity}}</h5>
                        <p class="mb-0">Side Stone <br>Clarity</p>
                    </div>
                    <div class="ring_box_right">
                        <img width="100" height="100"
                        :src="'/loose_setting/' + lowercase(detailData.setting.d_clarity) + '.svg'"
                        alt="Diamond Clarity" />
                    </div>
                    <div class="top-icon">
                        <SvgHeaderSvg :type="'ask'" />
                    </div>
                </div>
                

            </div>
        </div>
        <!-- test commit -->

        <!-- Below Lies Instock Diamond Details -->
        <div class="diam_one mt-4 mt-md-5" v-if="['in-stock-ring', 'in-stock-earring', 'in-stock-pendant'].includes(detailData.sub_type)">
            <div class="mb-3 title_flex" @click="toggleSingle()">
                <div class="font-active">
                    <span>Diamond Details </span>
                </div>
                <SvgHeaderSvg class="for_mobile" :type="drowdown ? 'up' : 'down'" />
            </div>

            <div class="ring_data_flex" :class="drowdown ? 'show' : 'hide'">
                <div class="ring_box" @click="showModal(diamondParameters.carat)">
                    <div class="ring_box_left">
                        <h5 class="mb-1">{{ detailData.stone_one_weight}} Ct</h5>
                        <p>Carat</p>
                    </div>
                    <div class="ring_box_right">
                        <img width="100" height="100" :src="'/loose_setting/' + lowercase(detailData.stone_one_shape) + '.svg'" alt="carat" />
                    </div>
                    <div class="top-icon" >
                        <span class="svgask">
                            <SvgHeaderSvg :type="'ask'" />
                        </span>
                    </div>
                </div>
                <div class="ring_box" @click="showModal(diamondParameters.clarity)">
                    <div class="ring_box_left">
                        <h5 class="mb-1">{{ detailData.stone_one_clarity }}</h5>
                        <p>Clarity</p>
                    </div>
                    <div class="ring_box_right">
                        <img width="100" height="100" :src="'/loose_graphics/clarity/' + lowercase(detailData.stone_one_clarity) + '.svg'" alt="Diamond Clarity" />
                    </div>
                    <div class="top-icon" >
                        <span class="svgask">
                            <SvgHeaderSvg :type="'ask'" />
                        </span>
                    </div>
                </div>
                <div class="ring_box" @click="showModal(diamondParameters.color)">
                    <div class="ring_box_left">
                        <h5 class="mb-1">{{ detailData.stone_one_color }}</h5>
                        <p>Color</p>
                    </div>
                    <div class="ring_box_right">
                        <img width="100" height="100" :src="'/loose_graphics/color/' + lowercase(detailData.stone_one_color) + '.svg'"
                            alt="color" />
                    </div>
                    <div class="top-icon" >
                        <span class="svgask">
                            <SvgHeaderSvg :type="'ask'" />
                        </span>
                    </div>
                </div>
                <!-- <div class="ring_box">
                    <div class="ring_box_left">
                        <h5 class="mb-1">{{ detailData.cut_grade }}</h5>
                        <p>Cut</p>
                    </div>
                    <div class="ring_box_right">
                        <img width="100" height="100" :src="'/loose_graphics/newcut/' + lowercase(detailData.cut_grade) + '.svg'"
                            alt="cut" />
                    </div>
                    <div class="top-icon" @click="showModal(diamondParameters.cut)">
                        <span class="svgask">
                            <SvgHeaderSvg :type="'ask'" />
                        </span>
                    </div>
                </div> -->
            </div>
        </div>

        <div v-else>
            <!-- Below Lies Diamond Details -->
            <div class="setting_details mt-md-5" v-if="currentMetal.shape != ''">
    
                <div class="mb-2 title_flex" @click="toggleSingle()">
                    <div class="font-active">
                        <span>Diamond details</span> 
                    </div>
                    <SvgHeaderSvg class="for_mobile" :type="drowdown ? 'up' : 'down'" />
                </div>
            
                <div class="ring_data_flex" :class="drowdown ? 'show' : 'hide'">
                    <div class="ring_box" @click="openModal(ringParams.weight)">
                        <div class="ring_box_left">
                            <h5 class="title_h5 caps">{{ currentCarat.value }} ct. tw.</h5>
                            <p class="mb-0">Min. Total Carat</p>
                        </div>
                        <div class="ring_box_right">
                            <img width="100" height="72" src="~/assets/loose_setting/totalctwt.svg" alt="Total CT WT" />
                        </div>
                        <div class="top-icon">
                            <SvgHeaderSvg :type="'ask'" />
                        </div>
                    </div>
                    
                    <div class="ring_box" @click="openModal(ringParams.sidecolor)">
                        <div class="ring_box_left">
                            <h5 class="title_h5 caps">{{currentCarat.d_color}}</h5>
                            <p class="mb-0">Average Color</p>
                        </div>
                        <div class="ring_box_right mt-md-2">
                            <img width="100" height="72" :src="'/loose_setting/' + lowercase(currentCarat.d_color) + '.svg'" alt="Side Stone Color" />
                        </div>
                        <div class="top-icon">
                            <SvgHeaderSvg :type="'ask'" />
                        </div>
                    </div>
                    
                    <div class="ring_box" @click="openModal(ringParams.sideclarity)">
                        <div class="ring_box_left">
                            <h5 class="title_h5 caps">{{ currentCarat.d_clarity }}</h5>
                            <p class="mb-0">Average Clarity</p>
                        </div>
                        <div class="ring_box_right mt-md-2">
                            <img width="100" height="72" :src="'/loose_setting/' + lowercase(currentCarat.d_clarity) + '.svg'" alt="Style"/>
                        </div>
                        <div class="top-icon">
                            <SvgHeaderSvg :type="'ask'" />
                        </div>
                    </div>
                    
                    <div class="ring_box" @click="openModal(ringParams.newshape)">
                        <div class="ring_box_left">
                            <h5 class="title_h5 caps">{{ addtionalAttirbute.num_lots }}</h5>
                            <p class="mb-0">Diamond Quantity</p>
                        </div>
                        <div class="ring_box_right pe-md-1">
                            <img v-if="currentMetal.shape.trim().split(/\s+/).length === 1"
                            width="72" height="65"
                            :src="`/loose_setting/${lowercase(currentMetal.shape)}.svg`"
                            alt="Shape" />
                        
                            <img v-else width="100" height="72" src="~/assets/loose_setting/diamond.svg" alt="Diamond" />
                        </div>
                        <div class="top-icon">
                            <SvgHeaderSvg :type="'ask'" />
                        </div>
                    </div>
                    
                </div>
    
            </div>
        </div>
              



        <div class="mt-3 mt-md-4" v-if="currentCarat">
            <div class="ring_title mb-2 ms-md-2">
            <span class="prod_title">{{currentCarat.product_name}}</span>    
            <span class="for_desktop"> | </span>
            <span class="prod_sku">SKU : {{ currentMetal.main_sku }}</span>
            </div>
            <div class="ring_desc ms-md-2">
                <span>{{currentCarat.long_desc}}</span>
            </div>
        </div> 

        <ModalLooseDetailModal 
            ref="modalRef"
            v-if="flagShowModal" 
            :active-index="activeIndex" 
            :key="`${activeIndex}_diamond_detail_attr_modal`"
            :diamond-parameters="diamondParameters"
            :id="`modal-${activeIndex}`"
            @close="hideModal" :dData="detailData"
        />

        <ModalSettingStyle 
            :id="`modal-${ringParams.newstyle}`"
            @close="notOpenModal"
            :ringParams="ringParams"
            v-if="flagShowModalReturn && ringBox === ringParams.newstyle"
            :ringBox="ringBox"
            :item="detailData" :detailData="detailData" title="Style"
        />

        <ModalSettingBandwidth 
            :id="`modal-${ringParams.newwidth}`"
            @close="notOpenModal"
            :ringParams="ringParams"
            v-if="flagShowModalReturn && ringBox === ringParams.newwidth"
            :ringBox="ringBox"
            title="Average Width"
            :item="detailData.sub_type === 'in-stock-ring'  ? (detailData.setting.min_width && detailData.setting.max_width 
            ? `${detailData.setting.min_width} / ${detailData.setting.max_width}`  : addtionalAttirbute.average_width )
            : addtionalAttirbute.average_width " :detailData="detailData"
        />


        <ModalSettingTotalWeight 
            :id="`modal-${ringParams.weight}`"
            @close="notOpenModal"
            :ringParams="ringParams"
            v-if="flagShowModalReturn && ringBox === ringParams.weight"
            :ringBox="ringBox"
            :item="detailData.lot_weight" 
            title="Total Carat Weight" 
        />

        <ModalSettingSideQuantity 
            :id="`modal-${ringParams.sideQuantity}`"
            @close="notOpenModal"
            :ringParams="ringParams"
            v-if="flagShowModalReturn && ringBox === ringParams.sideQuantity"
            :ringBox="ringBox"
            :item="detailData" title="Side Stone Quantity" :detailData="detailData.category"
        />

        <ModalSettingSideColour
            ref="newModalColor"
            :id="`modal-${ringParams.sidecolor}`"
            @close="notOpenModal"
            :ringParams="ringParams"
            v-if="flagShowModalReturn && ringBox === ringParams.sidecolor"
            :ringBox="ringBox"
            :item="detailData.d_color" title="Side Stone Color" :detailData="detailData.sub_type" 
        />

        <ModalSettingSideClarity 
            ref="newModalClarity"
            :id="`modal-${ringParams.sideclarity}`"
            @close="notOpenModal"
            :ringParams="ringParams"
            v-if="flagShowModalReturn && ringBox === ringParams.sideclarity"
            :ringBox="ringBox"    
            :item="detailData.d_clarity" title="Side Stone Clarity" :detailData="detailData.sub_type"
        />


        <ModalSettingTotalWeight
            :id="`modal-${ringParams.weight}`"
            @close="notOpenModal"
            :ringParams="ringParams"
            v-if="flagShowModalReturn && ringBox === ringParams.weight"
            :ringBox="ringBox"
            :item="currentCarat.value"
            title="Min. Total Carat Weight"
            :detailData="detailData.category"
        />

        <ModalSettingSideColour
            :id="`modal-${ringParams.sidecolor}`"
            @close="notOpenModal"
            :ringParams="ringParams"
            v-if="flagShowModalReturn && ringBox === ringParams.sidecolor"
            :ringBox="ringBox"
            :item="currentCarat.d_color"
            title="Average Color"
            :detailData="detailData.sub_type"
        />

        <ModalSettingSideClarity
            :id="`modal-${ringParams.sideclarity}`"
            @close="notOpenModal"
            :ringParams="ringParams"
            v-if="flagShowModalReturn && ringBox === ringParams.sideclarity"
            :ringBox="ringBox"
            :item="currentCarat.d_clarity" :detailData="detailData.sub_type" title="Average Clarity" 
        />

        <ModalSettingShape 
            :id="`modal-${ringParams.newshape}`"
            @close="notOpenModal"
            :ringBox="ringBox"
            :ringParams="ringParams"
            v-if="flagShowModalReturn && ringBox === ringParams.newshape"
            :currentMetal="currentMetal" :addtionalAttirbute="addtionalAttirbute.num_lots" :detailData="detailData.category"
        />

    </section>
</template>

<script setup>

    import { shopdetailStore }  from '@/stores/shop_detail/shop_detail';
    const store = shopdetailStore()
    const dropring = ref(true);
    const drowdown = ref(true);
    const route = useRoute()
    const modalRef=ref(null)
    
    const newModalColor = ref(null);

    const newModalClarity = ref(null);

	const flagShowModal = ref(false)
	const flagShowModalReturn = ref(false)
	const show = ref(false);
	const activeIndex = ref('');
	const ringBox = ref('');

    const tabs = reactive({
        setting:true,   
        cen_stone:false,
        accent_stone:false,
    })

    const toggleRing = () => {
	    dropring.value = !dropring.value;
    };
    const lowercase = (value) => {
        return value.toLowerCase().replace(/[^\w\s]/gi, '');
    }  
    const toggleSingle = () => {
	    drowdown.value = !drowdown.value;
    };

    const detailData = computed(() => {
        return store.getDetailData
    })

    const currentMetal = computed(() => {
        return store.getCurrentActive('metal')
    })

    const currentCarat = computed(() => {
        return store.getCurrentActive('carat')
    })
    
    const addtionalData = computed(() => {
        return store.getAdditionalDetails
    })

    const labelSettingDetail = computed(() => {
        
        const sub_type = detailData.value.sub_type
        
        const rings = ['full-eternity-ring','toi-et-moi-ring', 'anniversary-ring', 'couple-bands-ring', 'band-ring']
        const eng_rings = ['engagement-ring', 'in-stock-ring', 'in-stock-pendant', 'in-stock-earring']
        const bracelets = ['tennis-bracelet']
        const necklaces = ['tennis-necklace','solitaire-necklace']
        const studs = ['earring', 'stud-earring','fashion-earring']
        const hoops = ['hoop-earring']

        if(!sub_type){

            return ''
        }else if( rings.includes( sub_type )  ){

            return 'Band Details'
        }
        else if( eng_rings.includes( sub_type )  ){

            return 'Setting Details'
        }
        else if( bracelets.includes( sub_type )  ){

            return 'Bracelet Details'
        }
        else if( necklaces.includes( sub_type )  ){

            return 'Necklace Details'
        }
        else if( studs.includes( sub_type )  ){

            return 'Stud Details'
        }
        else if( hoops.includes( sub_type )  ){

            return 'Hoop Details'
        }
        return ''

    })

    const currentSize = computed(() => {
        let type
        if(['tennis-necklace', 'solitaire-necklace', 'tennis-bracelet'].includes(detailData.value.sub_type)){
            type = 'chain_length'
        }
        
        if(['stud-earring' || 'fashion-earring'].includes(detailData.value.sub_type)){
            type = 'back_type'
        }
        if(['full-eternity-ring','toi-et-moi-ring', 'band-ring', 'anniversary-ring'].includes(detailData.value.sub_type)){
            type = 'size'
        }
        if(['couple-bands-ring'].includes(detailData.value.sub_type)){
            type = 'his_size'
        }

        return store.getCurrentActiveAttribute(type)
    })
    
    const addtionalAttirbute = computed(() => {
        let size = null
        if(currentSize.value){
            size = currentSize.value.value
        }
        if( addtionalData.value && size !== undefined  ){

            const filteredData = addtionalData.value.find( cv => cv.size_attribute == size )

            if( filteredData !== undefined ){

                return filteredData
            }
        }
        if( currentCarat.value !== undefined ){

            return currentCarat.value
        } 

        return null
    })

    const numLots = computed(() => {

        const filteredData = addtionalAttirbute.value

        if( filteredData !== null ){

            return filteredData.num_lots
        }

        if( currentCarat.value !== undefined ){

            return currentCarat.value.num_lots
        } 

        return ''

    })


    function toggleDetails( type ){
        tabs.setting = false
        tabs.accent_stone = false
        tabs.cen_stone = false

        tabs[type] = true
    }

    onMounted( async () => {
        await store.setAdditionalDetails({ slug: route.params.slug })
    })	

    const diamondParameters = {
		color: 'color',
		cut: 'cut',
		carat: 'carat',
		clarity: 'clarity'
	}
    const ringParams = {
        weight : 'weight',
        sidecolor : 'sidecolor',
        sideclarity : 'sideclarity',
        newshape : 'newshape',
        newstyle : 'newstyle',
        newwidth : 'newwidth',
        sideQuantity : 'sideQuantity',
    }
	const dropdowns = reactive({
		1: false,
		2: false
	});

	function toggleBox(diamondNumber) {
		dropdowns[diamondNumber] = !dropdowns[diamondNumber];
	}

	const showModal = (boxNumber) => {
		flagShowModal.value = true;
		activeIndex.value = boxNumber;
		nextTick(() => {
			const modalElement = document.getElementById(`modal-${activeIndex.value}`);
			if (modalElement) {
				const modalInstance = new bootstrap.Modal(modalElement);
				modalInstance.show();
			}
            modalElement.addEventListener('shown.bs.modal', () => {
                if (modalRef.value) {
                    modalRef.value.scrollToHighlightedImage();
                    modalRef.value.scrollToclairtyImage();
                    modalRef.value.handleScrollToHighlightedImage();
                }
            });
		});
	};

	const hideModal = () => {
    const modalElement = document.getElementById(`modal-${activeIndex.value}`);
    if (modalElement) {
        const modalInstance = bootstrap.Modal.getInstance(modalElement);
        if (modalInstance) {
            modalInstance.hide();
        }
    }
    flagShowModal.value = false;
    };

    const openModal = (newbox) => {
        ringBox.value = newbox;
        flagShowModalReturn.value = true; 
        console.log(ringBox.value,'abc',newbox);
        
        nextTick(() => {
            const modalElement = document.getElementById(`modal-${ringBox.value}`);
            console.log(modalElement,'asd',ringBox.value);
            
            if (modalElement) {
                const modalInstance = new bootstrap.Modal(modalElement);
                modalInstance.show();
            }
            modalElement.addEventListener('shown.bs.modal', () => {
                if (newModalColor.value) {
                    newModalColor.value.scrollToHighlightedImage();
                }
                if(newModalClarity.value) {
                    newModalClarity.value.scrollToclairtyImage();
                }
            });
        });
    }

    const notOpenModal = () => {
                const modalElement = document.getElementById(`modal-${ringBox.value}`);
                if (modalElement) {
                    const modalInstance = bootstrap.Modal.getInstance(modalElement);
                    if (modalInstance) {
                        modalInstance.hide();
                    }
                }
                    flagShowModalReturn.value = false;
                    ringBox.value = '';
    };

</script>

<style scoped>
    
    .title_flex{
        font-size: 28px;
        text-align: center;
        color: #242529;
        text-transform: capitalize;
    }
    .ring_data_flex {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-wrap: wrap;
    }

    .ring_box {
        width: 23%;
        border: 1px solid #eaeaea;
        border-radius: 8px;
        margin: 10px;
        padding: 13px;
        position: relative;
        display: flex;
        align-items: flex-start;
        min-height: 100px;
        cursor: pointer;
    }

    .hoop_mod {
        cursor: default;
    }

    .top-icon {
        position: absolute;
        top: 4px;
        right: 2px;
        cursor: pointer;
    }

    .ring_box_left {
        width: 60%;
    }

    .ring_box_right {
        width: 40%;
        text-align: right;
    }

    h5 {
        font-size: 20px;
        color: #212529;
        text-transform: capitalize;
        font-weight: 600;
        margin-bottom: 5px;
    }

    .ring_box_left p {
        font-size: 14px;
        color: #606060;
        text-transform: uppercase;
        letter-spacing: 1px;
    }
   
    .ring_desc{
        font-size: 16px;
        color : #606060;
    }
    .prod_sku{
        font-size: 16px;
        color: #606060;
    }
    .prod_title{
        font-size: 16px;
        color: #353535;
        font-weight: 600;
    }

    .non_cap{
        text-transform: lowercase;
    }
    @media(max-width: 1150px){
        .ring_box{
            margin: 5px;
        }
        h5{
            font-size: 16px;
        }
    }
    @media(max-width: 992px){
        .ring_data_flex{
            flex-wrap: wrap;
            /* justify-content: space-between; */
        }
        .ring_box{
            width: 31%;
            margin: 7px;

        }
    }
    @media(max-width: 767px){
        .ring_data_flex.hide {
            display: none;
        }
        .ring_data_flex{
            justify-content: space-between;
        }
        .ring_box{
            width: 48%;
            flex-wrap: wrap;
            flex-direction: column-reverse;
            padding: 13px 5px;
            margin: 6px 0;
            min-height: 155px;
        }
        .ring_box_left, .ring_box_right{
            width: 100%;
            text-align: center;
        }
        .ring_box_left p {
            font-size: 12px;
        }
        .title_flex {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 18px;
        }
        .ring_box_left {
            margin-top: 10px;
        }

        .prod_title , .prod_sku ,  .ring_desc {
            font-size: 14px;
            display: block;
        }
    }
</style>